/* stylelint-disable */
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { Box } from '../../../../../Common/BoxV2';
import { GAP_FILL_PARAGRAPH_TOGGLE_TYPES } from '../../types';

export const ParagraphToggleOverrided = (props: RenderElementProps) => {
  const { element, children, attributes } = props;

  switch (element.present) {
    case GAP_FILL_PARAGRAPH_TOGGLE_TYPES.GUIDE:
      return <NormalParagraph {...props} />;
    case GAP_FILL_PARAGRAPH_TOGGLE_TYPES.HEADING:
      return <HeadingParagraph {...props} />;

    default:
      return <p {...attributes}>{children}</p>;
  }
};

function NormalParagraph(props: RenderElementProps) {
  const { children, attributes, element, ...rest } = props;

  return (
    <Style display={element.visible ? 'block' : 'none'} {...attributes} {...rest}>
      {children}
    </Style>
  );
}

const Style = styled(Box)`
  &&& {
    user-select: none;

    p {
      margin: 0;
    }
  }
`;

const HeadingParagraph = styled(NormalParagraph)`
  margin-bottom: 12px;
`;
